import getURLParams from 'utils/DOM/getURLParams'

export const forMultiCarrier = state => {
  const urlParams = getURLParams()
  const months = urlParams['months'] ? parseInt(urlParams['months']) : 0

  const mcPlans =
    state.plansToShow && state.plansToShow.length > 0
      ? state.plansToShow
          .map(p => {
            let planId
            if (typeof p === 'string') {
              planId = p.split('-')[0]
            } else if (typeof p === 'number') {
              planId = p
            }

            if (planId != null && state.plans[planId])
              return state.plans[planId].multiCarrierPlan
            return false
          })
          .some(Boolean)
      : false

  return state.eligibilityBool && state.eligibilityMonths > 4 && (months > 4 || mcPlans)
}
